import React, { useEffect, useState } from "react";
import cn from "classnames";
import { useHistory } from "react-router";
import { FormattedMessage } from "react-intl";

import Icon from "../../../icon";

import {
    UpperMenu,
    MenuRight,
    MenuLeft,
    Progress,
    ArrowButton,
    JoinBanner,
    Button,
    MenuOpener,
    MenuDropdown,
    GiveUp,
} from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const Menu = ({
    taskIndex,
    plan,
    restartHomework,
    restart,
    switchIsLow,
    isNextEnabled,
    canGiveUp,
    handleGiveUp,
    isFetching,
    isExperience,
    results,
    goToPage,
}: IProps) => {
    const history = useHistory();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const go = () => {
        taskIndex = Math.min(taskIndex! + 1, plan.tasks.length);
        goToPage(taskIndex);
    };
    useEffect(() => {
        return () => {
            window.removeEventListener("click", clickOutside);
        }
    }, []);
    const clickOutside = () => {
        setIsMenuOpen(false);
        window.removeEventListener("click", clickOutside);
    };
    const handleOpenMobileMenu = () => {
        if (!isMenuOpen) {
            setTimeout(() => {
                window.addEventListener("click", clickOutside);
            });
        }
        setIsMenuOpen(old => !old);
    };

    return (
        <UpperMenu>
            <MenuLeft>
                <MenuOpener onClick={handleOpenMobileMenu}>
                    <div className={cn(isMenuOpen && "Active")}>
                        <div className={cn("Line", "Line1")}></div>
                        <div className={cn("Line", "Line2")}></div>
                        <div className={cn("Line", "Line3")}></div>
                    </div>
                </MenuOpener>
                {isMenuOpen && (
                    <MenuDropdown>
                        {taskIndex !== null && !results[taskIndex] && (
                            <Button onClick={restart}>
                                <Icon i="refresh" />
                                <FormattedMessage {...messages.restartTask} />
                            </Button>
                        )}
                        <Button onClick={restartHomework}>
                            <Icon i="restart-homework" />
                            <FormattedMessage {...messages.restartHomework} />
                        </Button>
                        {!isExperience && (
                            <Button onClick={switchIsLow}>
                                <Icon i="toggle-appearance" />
                                <FormattedMessage {...messages.fancyUI} />
                            </Button>
                        )}
                        <Button onClick={history.goBack}>
                            <Icon i="exit-homework" />
                            <FormattedMessage {...messages.exitHomework} />
                        </Button>
                    </MenuDropdown>
                )}
            </MenuLeft>
            <JoinBanner>{plan.name}</JoinBanner>
            <MenuRight>
                {taskIndex !== null && (
                    <GiveUp disabled={!canGiveUp} onClick={handleGiveUp}>
                        <FormattedMessage {...messages.giveUp} />
                    </GiveUp>
                )}
                {!isExperience && (
                    <Progress>
                        {taskIndex! + 1} / {plan.tasks.length}
                    </Progress>
                )}
                {!isExperience && (
                    <ArrowButton
                        className={cn((!isNextEnabled || isFetching) && "Inactive", "Flip")}
                        onClick={go}
                    >
                        <Icon i="arrowback" />
                    </ArrowButton>
                )}
            </MenuRight>
        </UpperMenu>
    );
}

export default Menu;
